import type { RateTeamSquadMember } from '@lib/api/team-rating';
import type { QuizPlayer, QuizTeamMember } from 'types/quiz-player';

export const mapSquadMember = (member: RateTeamSquadMember): QuizPlayer => ({
  id: member.id,
  displayName: member.displayName,
  position: member.position,
  team: member.team,
  price: member.price,
  selectedByPercent: member.selectedByPercent,
  fixtures: member.fixtures,
  isCaptain: member.isCaptain,
  isViceCaptain: member.isViceCaptain
});

export const mapSquadToTeam = (
  squad: RateTeamSquadMember[]
): QuizTeamMember[] =>
  [...squad]
    .sort((a, b) => a.slot - b.slot)
    .map((member, index) => ({
      playerId: index,
      player: mapSquadMember(member)
    }));
